// A route identifies one object. Missing/stale IDs must never select another item.
export function selectedObject<T extends { id: string }>(items: readonly T[], id?: string | null): T | undefined {
  return id ? items.find((item) => item.id === id) : undefined;
}
